var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.75 9H9.58333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.965 10H17.4714C15.7608 10 14.375 11.343 14.375 13C14.375 14.657 15.7617 16 17.4704 16H19.965C20.0455 16 20.0847 16 20.1183 15.998C20.6358 15.965 21.0479 15.566 21.0814 15.065C21.0833 15.033 21.0833 14.994 21.0833 14.917V11.083C21.0833 11.006 21.0833 10.967 21.0814 10.935C21.0469 10.434 20.6358 10.035 20.1183 10.002C20.0847 10 20.0455 10 19.965 10Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0915 10C20.0167 8.128 19.7771 6.98 19.0018 6.172C17.8796 5 16.0722 5 12.4583 5H9.58333C5.96946 5 4.16204 5 3.03983 6.172C1.91666 7.343 1.91666 9.229 1.91666 13C1.91666 16.771 1.91666 18.657 3.03983 19.828C4.16204 21 5.96946 21 9.58333 21H12.4583C16.0722 21 17.8796 21 19.0018 19.828C19.7771 19.02 20.0177 17.872 20.0915 16",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.75 5.00053L9.32937 2.52353C9.83275 2.18186 10.4203 2 11.0208 2C11.6213 2 12.2089 2.18186 12.7123 2.52353L16.2917 5.00053",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.2414 13H17.2515",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDeposit);
export default __webpack_public_path__ + "static/media/dashboard_deposit.063af5a071cd0c00d54f0d0c048ec69b.svg";
export { ForwardRef as ReactComponent };